export default {"src":"/_next/static/media/press-hero-bg-pattern.c5e3a7c3.svg","height":543,"width":629,"blurWidth":0,"blurHeight":0};